import {toast} from "sonner";

let pinturaModulePromise;
let lastPinturaChunkErrorToastAt = 0;

const PINTURA_CHUNK_LOAD_ERROR = 'PINTURA_CHUNK_LOAD_ERROR';
const TOAST_DEDUP_WINDOW_MS = 4000;

function isLikelyChunkLoadError(error) {
    if (!error) return false;

    const name = `${error.name || ''}`.toLowerCase();
    const message = `${error.message || error}`.toLowerCase();

    return (
        name.includes('chunkload') ||
        message.includes('loading chunk') ||
        message.includes('failed to fetch dynamically imported module') ||
        message.includes('importing a module script failed') ||
        message.includes('dynamically imported module')
    );
}

function wrapPinturaChunkLoadError(error) {
    const wrappedError = new Error('Failed to load pintura editor chunk');
    wrappedError.code = PINTURA_CHUNK_LOAD_ERROR;
    wrappedError.originalError = error;
    return wrappedError;
}

export function isPinturaChunkLoadError(error) {
    return error?.code === PINTURA_CHUNK_LOAD_ERROR;
}

export async function loadPinturaModule() {
    if (!pinturaModulePromise) {
        pinturaModulePromise = import('pintura')
            .catch((error) => {
                // Allow retries after transient network/chunk failures.
                pinturaModulePromise = null;

                if (isLikelyChunkLoadError(error)) {
                    throw wrapPinturaChunkLoadError(error);
                }

                throw error;
            });
    }

    return pinturaModulePromise;
}

export function preloadPinturaModule() {
    return loadPinturaModule();
}

export function notifyPinturaChunkLoadError(error) {
    if (!isPinturaChunkLoadError(error)) return false;

    const now = Date.now();
    if (now - lastPinturaChunkErrorToastAt < TOAST_DEDUP_WINDOW_MS) {
        return true;
    }

    lastPinturaChunkErrorToastAt = now;
    toast.error('Could not load image editor. Check connection and try again.');
    return true;
}
